import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';

interface ResolvedTitleContextValue {
  resolvedTitle: string | undefined;
  setResolvedTitle: (value: string | undefined) => void;
}

const ResolvedTitleContext = createContext<ResolvedTitleContextValue>({
  resolvedTitle: undefined,
  setResolvedTitle: () => {},
});

export const ResolvedTitleProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [resolvedTitle, setResolvedTitle] = useState<string | undefined>(
    undefined,
  );
  return (
    <ResolvedTitleContext.Provider value={{ resolvedTitle, setResolvedTitle }}>
      {children}
    </ResolvedTitleContext.Provider>
  );
};

export const useResolvedTitle = () =>
  useContext(ResolvedTitleContext).resolvedTitle;

export const useSetResolvedTitle = (value: string | undefined) => {
  const { setResolvedTitle } = useContext(ResolvedTitleContext);
  useEffect(() => {
    setResolvedTitle(value);
    return () => setResolvedTitle(undefined);
  }, [value, setResolvedTitle]);
};
